import React from 'react';

export default function CompanyDetails() {
  return (
    <p style={{ clear: 'both' }}>
      Failbetter Games Limited is a company registered in England and Wales (7121579).
      We trade at Failbetter Games,
      20 St Thomas St, 
      London SE1 9RS
        Purchases are securely processed by
      {' '}
      <a className="link--inverse" href="https://www.braintreepayments.com/contact-us" target="braintree">Braintree Payments</a>
    </p>
  );
}

CompanyDetails.displayName = 'CompanyDetails';
